import { WCCContentAttachmentsBlock } from "components/content/blocks/attachments/attachments";
import { wccModules } from "enums/wccModules";
import { AttachmentsHelpers } from "helpers/attachments";
import { inject, injectable } from "inversify";
import { Subscribable } from "knockout";
import { CurrentUserManager } from "managers/currentUser";
import { IWCCStorageManager } from "managers/iStorage";
import WCCAudio from "models/attachments/audio";
import WCCFile from "models/attachments/file";
import WCCVideo from "models/attachments/video";
import WCCContentBlockVM from "../block/block";
import './attachments.html';
import './attachments.scss';
import WCCImage from "../../../../models/attachments/image";

components.preload('photoset-new', 'attachment-caption', 'fancybox-image-new', 'wcc-image', 'wcc-video', 'grid-new', 'wcc-audio', 'wcc-file', 'attachment-transcript');

@injectable()
export default class WCCContentAttachmentsVM extends WCCContentBlockVM {
    id = _.uniqueId('content-attachments-');

    videos: Subscribable<Array<WCCVideo>>
    audios: Subscribable<Array<WCCAudio>>
    files: Subscribable<Array<WCCFile>>

    hasImages: Subscribable<boolean>
    hasCardSortImages: Subscribable<boolean>
    hasAudios: Subscribable<boolean>
    hasFiles: Subscribable<boolean>

    isTranscriptAllowed: Subscribable<boolean>
    isTitleNeeded: Subscribable<boolean>

    photoset: StringMap<any>

    constructor(
        @inject(wccModules.componentConfig) block: WCCContentAttachmentsBlock,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo,
        @inject(wccModules.storage) storage: IWCCStorageManager
    ) {
        super(block, info);

        const attachments = block.attachments;
        const columnWidth = block.columnWidth;
        const rowsCount = block.rowsCount;
        const isExpanded = block.expand;

        const userManager = storage.get(CurrentUserManager, {});
        const user = userManager.pluck(m => m.person);
        const isModerator = user.pluck(u => u.isModerator, false);
        this.isTranscriptAllowed = ko.pureComputed(() => (settings.isAdmin || isModerator()) && block.showTranscript());

        const images = attachments.filter(a => AttachmentsHelpers.isImage(a.fileType(), true));
        this.videos = attachments.filter(a => a.isVideo());
        this.audios = attachments.filter(a => a.isAudio());
        this.files = attachments.filter(a => a.isFile());

        this.hasImages = images.any();
        this.hasCardSortImages = images.any(i => {
            try {
                return (i as WCCImage).isCardSortImage();
            }
            catch (e) {
                return false;
            }
        });

        this.hasAudios = this.audios.any();
        this.hasFiles = this.files.any();

        this.isTitleNeeded = ko.pureComputed(() => this.hasImages() && (this.hasCardSortImages() && block.showTitle() || !this.hasCardSortImages() && images().length == 1));// block.showTitle;

        this.photoset = {
            source: images,
            offset: 5,
            columnWidth: columnWidth,
            rowsCount: rowsCount,
            colsCount: 4,
            expand: isExpanded,
            noUpscale: true,
            layout: 'fitRow',
            noSingleImageCaption: this.hasCardSortImages(),
        }
    }
}